import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ParkRulesImage from 'assets/images/not-allowed-icons.png';
import styles from './ParkRules.module.scss';

const ParkRules: FC = () => {
  const { t } = useTranslation();

  return (
    <Row className={styles.Container} justify="center">
      <Col span={24}>
        <p className={styles.ParkRulesTitle}>{t('pages.parkRules.notAllowed')}</p>
        <img src={ParkRulesImage} alt="Park Rules" className={styles.Image} />
        <p className={styles.ParkRulesTitle}>{t('pages.parkRules.disclaimer')}</p>
      </Col>
    </Row>
  );
};

export default ParkRules;
